/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  z as zod
} from 'zod';

import type {
  AssociationResponse,
  CreateBody
} from '../../../schemas';

import { customFetch } from '../../../../custom-fetcher';
import { customFormDataFn } from '../../../../custom-formdata';

export type createResponse201 = {
  data: void
  status: 201
}

export type createResponseSuccess = (createResponse201) & {
  headers: Headers;
};
;

export type createResponse = (createResponseSuccess)

export const getCreateUrl = () => {




  return `/api/v1/associations`
}

export const create = async (createBody?: CreateBody, options?: RequestInit): Promise<createResponse> => {
    const formData = customFormDataFn(createBody)
  return customFetch<createResponse>(getCreateUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}


export type findByMembershipIdResponse200 = {
  data: AssociationResponse
  status: 200
}

export type findByMembershipIdResponseSuccess = (findByMembershipIdResponse200) & {
  headers: Headers;
};
;

export type findByMembershipIdResponse = (findByMembershipIdResponseSuccess)

export const getFindByMembershipIdUrl = (membershipId: string,) => {




  return `/api/v1/associations/by-membership/${membershipId}`
}

export const findByMembershipId = async (membershipId: string, options?: RequestInit): Promise<findByMembershipIdResponse> => {

  return customFetch<findByMembershipIdResponse>(getFindByMembershipIdUrl(membershipId),
  {
    ...options,
    method: 'GET'


  }
);}


export type findByCreatorAccountResponse200 = {
  data: AssociationResponse[]
  status: 200
}

export type findByCreatorAccountResponseSuccess = (findByCreatorAccountResponse200) & {
  headers: Headers;
};
;

export type findByCreatorAccountResponse = (findByCreatorAccountResponseSuccess)

export const getFindByCreatorAccountUrl = () => {




  return `/api/v1/associations/by-creator-account`
}

/**
 * Lädt alle Vereine, die ich selbst angelegt habe. Nützlich um z.B. meine eigene Vorstandsmitgliedschaft zu erfassen. Hier kann ich nicht über die Schnittstelle findByMembershipAccountIdentifier gehen, da ich ja noch keine Mitgliedschaft in dem Verein habe.
 * @summary Lädt alle Vereine, die ich selbst angelegt habe
 */
export const findByCreatorAccount = async ( options?: RequestInit): Promise<findByCreatorAccountResponse> => {

  return customFetch<findByCreatorAccountResponse>(getFindByCreatorAccountUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


export type findByMembershipAccountIdentifierResponse200 = {
  data: AssociationResponse[]
  status: 200
}

export type findByMembershipAccountIdentifierResponseSuccess = (findByMembershipAccountIdentifierResponse200) & {
  headers: Headers;
};
;

export type findByMembershipAccountIdentifierResponse = (findByMembershipAccountIdentifierResponseSuccess)

export const getFindByMembershipAccountIdentifierUrl = () => {




  return `/api/v1/associations/by-account`
}

/**
 * Lädt alle Vereine, in denen ich eine Mitgliedschaft habe. Nützlich um z.B. beim Login die Vereinsauswahl angezeigt zu bekommen.
 * @summary Lädt alle Vereine, in denen ich eine Mitgliedschaft habe
 */
export const findByMembershipAccountIdentifier = async ( options?: RequestInit): Promise<findByMembershipAccountIdentifierResponse> => {

  return customFetch<findByMembershipAccountIdentifierResponse>(getFindByMembershipAccountIdentifierUrl(),
  {
    ...options,
    method: 'GET'


  }
);}


